module.exports = __webpack_public_path__ + "static/media/sa.e68f2514.svg";